<template>
  <div class="logo-improvement-form mt-10">
    <span>{{ $t('wizard-v2.small-details.provide-these-details') }}</span>
    <cv-dropdown
      :placeholder="$t('section.actions.choose-an-option')"
      :label="
        $t('wizard-v2.small-details.improvement-options.improvement-options')
      "
      size="lg"
      :light="true"
      class="mt-10"
      :value="logoImprovementFormData.reason"
      @change="
        (selectedOption) =>
          $emit('update-form', {
            ...logoImprovementFormData,
            improvementOption: selectedOption,
          })
      "
    >
      <cv-dropdown-item
        v-for="(option, index) in getTranslatedImprovementOptions"
        :key="index"
        :value="option"
        >{{ option }}</cv-dropdown-item
      >
    </cv-dropdown>
    <cv-text-area
      :light="true"
      class="logo-improvement-form__text-area mt-10"
      :label="
        $t(
          'wizard-v2.small-details.improvement-options.please-specify-your-needs'
        )
      "
      :value="logoImprovementFormData.comment"
      :placeholder="$t('section.actions.comment-placeholder')"
      @input="
        (text) =>
          $emit('update-form', {
            ...logoImprovementFormData,
            comment: text,
          })
      "
    ></cv-text-area>
    <div class="logo-improvement-form__file mt-10">
      <document-attachment-16 />
      <span class="ml-10"> {{ fileName }}</span>
    </div>
  </div>
</template>

<script>
import { IMPROVEMENT_OPTIONS } from '@/constants/smallDetails';
import { CvDropdown, CvDropdownItem, CvTextArea } from '@carbon/vue';
import DocumentAttachment16 from '@carbon/icons-vue/es/document--attachment/16';

export default {
  components: {
    CvDropdown,
    CvDropdownItem,
    CvTextArea,
    DocumentAttachment16,
  },
  props: {
    fileName: {
      type: String,
      default: '',
    },
    logoImprovementFormData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      IMPROVEMENT_OPTIONS,
    };
  },
  computed: {
    getTranslatedImprovementOptions() {
      return IMPROVEMENT_OPTIONS.map((item) => {
        const [key, value] = Object.entries(item)[0];
        return this.$t(`wizard-v2.small-details.improvement-options.${key}`);
      });
    },
  },
};
</script>

<style lang="scss">
.logo-improvement-form {
  font-size: 14px;
  width: 100%;
  padding: 10px;
  background: #f4f4f4;
  .bx--text-area__wrapper {
    height: 160px;
  }

  &__file {
    font-size: 14px;
    display: flex;
    width: 100%;
    background: white;
    padding: 10px;

    span {
      margin-left: 10px;
    }
  }
}

.logo-improvement-form .bx--label {
  font-size: 14px !important;
}

.logo-improvement-form .cv-dropdown-item {
  font-size: 14px !important;
}

.logo-improvement-form .bx--text-area {
  height: 160px;
  font-size: 14px !important;
}

.logo-improvement-form .bx--text-area::placeholder {
  font-size: 16px !important; /* Change the size here */
}

.logo-improvement-form .bx--list-box__label {
  font-size: 14px !important;
}
</style>
